import React from 'react';

interface PaginationLoaderProps {
  hasNextPage: boolean;
  loadNextPage: () => void;
  root?: React.RefObject<HTMLDivElement>;
  threshold?: number;
}

export default function PaginationLoader(props: PaginationLoaderProps) {
  const { hasNextPage, loadNextPage, root, threshold = 0 } = props;
  const ref = React.useRef<HTMLDivElement>(null);
  const [shouldObserve, setshouldObserve] = React.useState(true);

  React.useEffect(() => {
    const curr = ref.current;
    if (!curr) return;
    if (shouldObserve) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && hasNextPage) {
            loadNextPage();
            setshouldObserve(false);
            setTimeout(() => setshouldObserve(true), 50);
          }
        },
        {
          root: root?.current || null,
          rootMargin: '0px',
          threshold,
        },
      );
      observer.observe(curr);
      return () => {
        observer.unobserve(curr);
      };
    }
  }, [hasNextPage, loadNextPage, shouldObserve, ref, root, threshold]);

  if (!hasNextPage) return null;

  return (
    <div
      ref={ref}
      style={{
        width: '100%',
        minHeight: 1,
      }}
    />
  );
}
